module.exports = __webpack_public_path__ + "img/logo-dark.3d46c0cb.png";